"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var _Section = _interopRequireDefault(require("../../Card/Section"));

var _FontAwesome = _interopRequireDefault(require("../../Icon/FontAwesome"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Section for a `SideBar` Component.
 */
var SideBarSection =
/*#__PURE__*/
function (_Component) {
  _inherits(SideBarSection, _Component);

  function SideBarSection(props) {
    var _this;

    _classCallCheck(this, SideBarSection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideBarSection).call(this, props));
    _this.state = {
      isHovered: false
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleHover = _this.handleHover.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SideBarSection, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          index = _this$props.index,
          onClick = _this$props.onClick;
      return onClick(index);
    }
  }, {
    key: "handleHover",
    value: function handleHover() {
      this.setState({
        isHovered: !this.state.isHovered
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          accentColor = _this$props2.accentColor,
          icon = _this$props2.icon,
          isActive = _this$props2.isActive,
          style = _this$props2.style,
          text = _this$props2.text,
          textColor = _this$props2.textColor;
      var isHovered = this.state.isHovered;
      var handleClick = this.handleClick,
          handleHover = this.handleHover;
      var cardSectionStyle = {
        textAlign: "center"
      };
      var eventClass = '';

      if (isActive) {
        eventClass = '--active';
        cardSectionStyle.borderColor = accentColor;
        cardSectionStyle.color = accentColor;
        cardSectionStyle.backgroundColor = textColor;
      } else if (isHovered) {
        eventClass = '--hovered';
        cardSectionStyle.background = accentColor;
        cardSectionStyle.borderColor = textColor;
        cardSectionStyle.color = textColor;
      }

      var classes = (0, _utils.classList)('story-sidebar__section', eventClass);
      return _react.default.createElement("div", {
        className: classes,
        style: style,
        onClick: handleClick,
        onMouseEnter: handleHover,
        onMouseLeave: handleHover
      }, _react.default.createElement(_Section.default, {
        style: cardSectionStyle
      }, _react.default.createElement(_core.Grid, {
        container: true
      }, _react.default.createElement(_core.Grid, {
        item: true,
        xs: 3
      }, icon), _react.default.createElement(_core.Grid, {
        item: true,
        xs: 1
      }, _react.default.createElement(_core.Divider, {
        orientation: "vertical"
      })), _react.default.createElement(_core.Grid, {
        item: true,
        xs: 8,
        className: "story-sidebar-text"
      }, _react.default.createElement(_core.Typography, {
        variant: "subtitle2"
      }, text)))));
    }
  }]);

  return SideBarSection;
}(_react.Component);

exports.default = SideBarSection;

_defineProperty(SideBarSection, "propTypes", {
  /** The color to style the `SideBarSection` during events  */
  accentColor: _propTypes.default.string,

  /** The `SideBar` `Icon` that relates to the `Moment` */
  icon: _propTypes.default.element.isRequired,

  /** Way to disambiguate this `SideBarSection` during a callback  */
  index: _propTypes.default.any.isRequired,

  /** Determines if the `Moment` is currently rendered on the `Story`  */
  isActive: _propTypes.default.bool,

  /** Click handler callback used by the `SideBar` */
  onClick: _propTypes.default.func,

  /** Styling object of the `SideBar` */
  style: _propTypes.default.object,

  /** The `SideBar` label of the `Moment` */
  text: _propTypes.default.string.isRequired,

  /** The color to style the `SideBarSection` text when active  */
  textColor: _propTypes.default.string
});

_defineProperty(SideBarSection, "defaultProps", {
  icon: _react.default.createElement(_FontAwesome.default, {
    name: "FaInfoCircle"
  }),
  onClick: function onClick() {},
  style: {}
});